import { GridSortDirection } from '@mui/x-data-grid';
import { formatFilterQuery } from '~/utils';
import { Cluster, ListRes, PaginationReq } from '../../types';
import { v2Api } from '../v2Api';

export type ClusterQuery = {
  projectId: number;
  emrId: number;
  clusterId: number;
  name: string;
  primary_ec2_instance_type: string;
  core_ec2_instance_type: string;
  ebs_size: number;
  ebs_iops: number;
  ebs_throughput: number;
  metadata: Record<string, unknown>;
};

const tags = ['cluster'] as const;

const clusterApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      createCluster: builder.mutation<Cluster, ClusterQuery>({
        query: ({ projectId, emrId, ...body }) => ({
          url: `projects/${projectId}/emrs/${emrId}/clusters`,
          method: 'POST',
          body,
        }),
        invalidatesTags: tags,
      }),
      deleteCluster: builder.mutation<Cluster, { projectId: number; emrId: number; clusterId: number }>({
        query: ({ projectId, emrId, clusterId }) => ({
          url: `projects/${projectId}/emrs/${emrId}/clusters/${clusterId}`,
          method: 'DELETE',
        }),
        invalidatesTags: tags,
      }),
      getClusters: builder.query<
        ListRes<Cluster[]>,
        {
          projectId: number;
          emrId: number;
          search?: string;
          createdOn?: string[];
          statusList?: string[];
          createdBy?: string[];
          clusterId?: string[];
          sort?: string;
          sort_elapsed?: boolean;
          order?: GridSortDirection;
        } & PaginationReq
      >({
        query: ({
          projectId,
          emrId,
          search,
          createdOn,
          statusList,
          createdBy,
          clusterId,
          sort,
          order,
          sort_elapsed,
        }) => ({
          url: `projects/${projectId}/emrs/${emrId}/clusters?size=100${formatFilterQuery(sort_elapsed, 'sort_elapsed')}${formatFilterQuery(search, 'search')}${formatFilterQuery(createdOn, 'created')}${formatFilterQuery(statusList, 'status_list')}${formatFilterQuery(createdBy, 'created_by_list')}${formatFilterQuery(clusterId, 'cluster_id')}${formatFilterQuery(sort, 'sort')}${formatFilterQuery(order, 'order')}`,
        }),
        providesTags: tags,
      }),
    }),
  });

export default clusterApi;
